export default __webpack_public_path__ + "d7526860b37d2837d181386a441e1a38.svg";